exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!./../../../node_modules/css-loader/index.js?modules&importLoaders=1!./../../../node_modules/postcss-loader/index.js!@chartbeat/light-side/lib/styles/typography.cssm"), undefined);

// module
exports.push([module.id, "._3qtDUM58eQEnT1hFMkfxZ0{color:#fff;text-align:center;padding:45px 0 40px}.Nsy2h8tGBEQKJQej2iuYB{font-weight:100;font-size:60px;margin-top:6px}._2P7QvhtRyQY_2eAV2VY547{font-size:12px;opacity:.5}@media only screen and (max-width:425px){._3qtDUM58eQEnT1hFMkfxZ0{padding:32px 0 30px}.Nsy2h8tGBEQKJQej2iuYB{font-size:40px;margin-top:6px}}@media only screen and (max-width:325px){.Nsy2h8tGBEQKJQej2iuYB{font-size:30px}}", ""]);

// exports
exports.locals = {
	"bodySmallMetric": "" + require("-!./../../../node_modules/css-loader/index.js?modules&importLoaders=1!./../../../node_modules/postcss-loader/index.js!@chartbeat/light-side/lib/styles/typography.cssm").locals["bodySmallMetric"] + "",
	"container": "_3qtDUM58eQEnT1hFMkfxZ0",
	"counter": "Nsy2h8tGBEQKJQej2iuYB",
	"contextText": "_2P7QvhtRyQY_2eAV2VY547 " + require("-!./../../../node_modules/css-loader/index.js?modules&importLoaders=1!./../../../node_modules/postcss-loader/index.js!@chartbeat/light-side/lib/styles/typography.cssm").locals["bodySmallMetric"] + ""
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1!./~/postcss-loader!./src/components/total-counter/total-counter.cssm
// module id = 179
// module chunks = 0